import { Component, OnInit, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ApplicationDataCaptureService, SERVICE_END_POINT, UtilService, DealPartnerFunctionalityService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import * as UserDataConfig from '../../../config/user-data.config';
import { quoteLevelConstants } from '../../../../../shared/constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-application-summary',
  templateUrl: './application-summary.component.html',
  styleUrls: ['./application-summary.component.scss']
})
export class ApplicationSummaryComponent implements OnInit {

  // tslint:disable-next-line:no-output-on-prefix
  @Output() topNavCloseBtn: EventEmitter<any> = new EventEmitter<any>();
  @Input() productCode: string;
  @Input() submittedFlag;
  public contentData;
  protected cmsProductChoice;
  public summaryList = [];
  // protected productCode: string;
  protected resultQuote: {};
  public afterApplyDetail = UserDataConfig.ElementsConfig;
  responseApplicationData: any;
  quoteFundInfo: any;
  resPensionSavings: any;
  CMSData;
  constructor(private router: Router,
    private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    public el: ElementRef,
    private store: Store<AppState>,
    private utilService: UtilService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.applicationSummary;
    this.summaryList = this.activatedRoute.snapshot.data.contentData.applicationSummary.summaryList;
    this.cmsProductChoice = this.activatedRoute.snapshot.data.contentData.productChoice;
    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resultQuote = res[0];
      }
    });
    //capturing application store data
    store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val.length > 0) {
        this.responseApplicationData = val[0];
        this.quoteFundInfo = (this.responseApplicationData && this.responseApplicationData.quoteFundInfo
          && this.responseApplicationData.quoteFundInfo.length > 0)
          ? this.responseApplicationData.quoteFundInfo[0] : null;
        this.resPensionSavings = this.responseApplicationData.cedingPension[0];
      }
    });
  }

  ngOnInit() {
    this.afterApplyDetail['buttonConfigSummary']['label'] = this.contentData.btnCloseSummary;
    this.afterApplyDetail['buttonConfigSummary']['name'] = 'closeSummary';
    this.GetCMSDataServiceMapper();
    // // capturing the selected product code in Quote Journey
    // if (this.resultQuote) {
    //   this.productCode = this.cmsProductChoice.products.find(p => p.productCode === this.resultQuote['product']).productCode;
    // }

  }
  close() {
    this.topNavCloseBtn.emit();
  }
  getVisibility(list) {
    // hide beneficiary section if  "showBeneficiary is false"
    if (list.title && (list.title).trim() === 'Your beneficiary details') {
      list.visibility[0] = this.responseApplicationData && this.responseApplicationData.showBeneficiary === true ? true : false;
      list.visibility[1] = this.responseApplicationData && this.responseApplicationData.showBeneficiary === true ? true : false;
      list.visibility[2] = this.responseApplicationData && this.responseApplicationData.showBeneficiary === true ? true : false;
    }
    if (this.productCode === 'C') {
      // show/hide dependant sections based on dependant selection for LTA
      if (list.title === 'Your dependant personal\'s details') {
        if (this.responseApplicationData.secondLife !== null &&
          this.responseApplicationData.secondLife.dateOfBirth !== null) {
          if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes
            && DealPartnerFunctionalityService.gmpMaritalCheck(this.responseApplicationData.customer.maritalStatus)) {
            list.visibility[0] = true;
          } else {
            if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.no) {
              list.visibility[0] = true;
            } else {
              list.visibility[0] = false;
            }
          }
          if (DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])
            && DealPartnerFunctionalityService.gmpMaritalCheck(this.responseApplicationData.customer.maritalStatus)
            && DealPartnerFunctionalityService.spouseBenefit(this.quoteFundInfo, this.responseApplicationData['secondLife'])
            && this.resPensionSavings.productCode && this.resPensionSavings.productCode === "J10") {
            list.visibility[0] = false;
          }
        } else {
          list.visibility[0] = false;
        }
      }
      if (list.title === 'Your dependant\'s doctor\'s details') {
        // tslint:disable-next-line:max-line-length

        if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) {
          list.visibility[0] = false;
        } else {
          if (this.responseApplicationData.secondLife !== null && this.responseApplicationData.secondLife.dateOfBirth !== null) {
            if (DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])
              && DealPartnerFunctionalityService.gmpMaritalCheck(this.responseApplicationData.customer.maritalStatus)
              && DealPartnerFunctionalityService.spouseBenefit(this.quoteFundInfo, this.responseApplicationData['secondLife'])
              && this.resPensionSavings.productCode && this.resPensionSavings.productCode === "J10") {
              list.visibility[0] = false;
            } else {
              list.visibility[0] = true;
            }
          } else {
            list.visibility[0] = false;
          }
        }
      }
     
      if(list.title == 'Lump Sum Allowances') {
          list.visibility[0] = this.displayLSA();         
      }
      return list.visibility[0];
    } else if (this.productCode === 'H') {
      if (list.title == 'Lump Sum Allowances') {
        list.visibility[1] = this.displayLSA();
      }
      return list.visibility[1];
    } else if (this.productCode === 'G') {
      if (list.title == 'Lump Sum Allowances') {
        list.visibility[2] = this.displayLSA();
      }
      return list.visibility[2];
    }
  }

  displayLSA() {
    const lsaCheck = this.responseApplicationData.riskAndStaticQuestion.filter(val => (val.questionCode === 'lumpSumAllowanceQuestion' || 
    val.questionCode === 'lsaQuestion'));
    return (lsaCheck && lsaCheck.length > 0 ? true : false);
  }

  isGARProduct(garIndicator: string) {
    if (garIndicator === quoteLevelConstants.garIndicators.yes || garIndicator === quoteLevelConstants.garIndicators.ignored
      || garIndicator === quoteLevelConstants.garIndicators.beaten || garIndicator === quoteLevelConstants.garIndicators.featured) {
      return true;
    }
    return false;
  }

  getId(id_value) {
    var s = id_value.replace(/\s+(.)/g, function (match, chr) {
      return chr.toUpperCase();
    });
    s = s.charAt(0).toLowerCase() + s.substr(1);
    return s.replace(/[^\w\s]/g, '');
  }


  // getTitle(title) {
  //   if (this.productCode === 'H' && title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
  //     title = this.cmsData1.ftrpInfo;
  //   }
  //   if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[8].title) {
  //     title = this.cmsData1.corpInfo;
  //   }
  //   return title;
  // }

  // getVisibility(title) {
  //   let visibilityFlag = true;
  //   if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[1].title) {
  //     visibilityFlag = false;
  //   }
  //   if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[4].title) {
  //     visibilityFlag = false;
  //   }
  //   if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[5].title) {
  //     visibilityFlag = false;
  //   }
  //   if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[6].title) {
  //     visibilityFlag = false;
  //   }
  //   if (this.productCode === 'G' && title === this.contentData.pleaseConfirmDetails.playBack[7].title) {
  //     visibilityFlag = false;
  //   }
  //   return visibilityFlag;
  // }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_ApplicationSummary;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.title = this.CMSData.string_ApplicationSummaryTitle;
        this.contentData.introduction1 = this.CMSData.string_ApplicationSummarySubtitle1;
        this.contentData.introduction2 = this.CMSData.string_ApplicationSummarySubtitle2;
        this.contentData.applicationDate = this.CMSData.string_Applicationsubmissiondate;
        this.summaryList[1].title = this.CMSData.string_YourPensionsTitle;
        this.summaryList[5].title = this.CMSData.string_DoctorsDetailsTitle;
        this.summaryList[7].title = this.CMSData.string_IncomePaymentDetailsTitle;
        this.summaryList[8].title = this.CMSData.string_BeneficiaryDetails;
        this.summaryList[6].title = this.CMSData.string_DependantsDoctorsDetailsTitle1;
        this.contentData.btnClose = this.CMSData.string_CloseCTALabel;
        this.afterApplyDetail['buttonConfigSummary'].label = this.CMSData.string_CloseSummaryCTALabel;
      }
    });

  }
}
